<template>
  <b-card no-body>
    <template v-slot:header>
      <h2 class="mb-0">
        <template v-if="innerSet.id">Редактирование комплекта #{{ innerSet.id }}</template>
        <template v-else>Добавление комплекта</template>

        <button
            type="button"
            :disabled="! $page.props.can.sets.import"
            v-b-modal="'set-components-import-modal'"
            class="btn btn-outline-success btn-sm float-right">
          <font-awesome-icon icon="file-upload"/>
          Импорт состава комплекта
        </button>
      </h2>
    </template>

    <div class="block" v-if="Object.keys($page.props.errors).length > 0">
      <b-alert class="mb-0" variant="danger" :show="Object.keys($page.props.errors).length > 0">
        <h4 class="alert-heading">Исправьте ошибки и попробуйте сохранить снова</h4>
        <ul class="list-unstyled mb-0">
          <template v-for="(errors, name) in $page.props.errors">
            <li v-for="(error, i) in errors" :key="name+i">
              {{ error }}
            </li>
          </template>
        </ul>
      </b-alert>
    </div>

    <b-form @submit.prevent="onSubmit">
      <div class="block bg-galsen">
        <h3>Каталог</h3>
        <b-form-row>
          <div class="col-4">
            <b-form-group label="Направление и раздел">
              <b-form-select v-model="innerSet.section_id" :options="sectionsOptions"></b-form-select>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Внутренний №" :invalid-feedback="fieldError('inner_id')">
              <b-input v-model="innerSet.inner_id"
                       :state="fieldState('inner_id')"></b-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Сортировка" :invalid-feedback="fieldError('order')">
              <b-input v-model="innerSet.order"
                       type="number"
                       :state="fieldState('order')"></b-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Код" :invalid-feedback="fieldError('code')">
              <b-input v-model="innerSet.code"
                       :state="fieldState('code')"></b-input>
            </b-form-group>
          </div>

          <div class="col">
            <b-form-group label="URL" :invalid-feedback="fieldError('slug')">
              <b-input v-model="innerSet.slug"
                       :state="fieldState('slug')"></b-input>
            </b-form-group>
          </div>
        </b-form-row>

      </div>

      <div class="block">
        <h3>Характеристики</h3>
        <b-form-row>
          <div class="col-2">
            <b-form-group label="Кол-во лаб. работ" :invalid-feedback="fieldError('experiments_count')" class="mr-5">
              <b-form-input v-model="innerSet.experiments_count" type="number"
                                 :state="fieldState('experiments_count')"></b-form-input>
            </b-form-group>
            <b-form-group label="Рабочие места" :invalid-feedback="fieldError('workplaces')" class="mr-5">
              <b-form-input v-model="innerSet.workplaces" type="number"
                                 :state="fieldState('workplaces')"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-2">
            <b-form-group label="Уровень образования" :invalid-feedback="fieldError('education_levels')" :state="fieldState('education_levels')">
              <b-form-checkbox-group
                  v-model="innerSet.education_levels"
                  :options="[{text: 'НПО', value: 1},{text: 'СПО', value: 2},{text: 'ВПО', value: 3},{text: 'ДПО', value: 4}]"
                  :state="fieldState('education_levels')"
                  stacked
                  switches
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div class="col-2">
            <b-form-group label="Исполнение" :invalid-feedback="fieldError('implementation')">
              <b-form-radio-group
                  v-model="innerSet.implementation"
                  :options="[{text: 'Стендовое', value: 1},{text: 'Настольное', value: 2},{text: 'Портативное', value: 3}]"
                  :state="fieldState('implementation')"
                  stacked
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-2">
            <b-form-group label="Управление" :invalid-feedback="fieldError('control')">
              <b-form-radio-group
                  v-model="innerSet.control"
                  :options="[{text: 'Ручное', value: 1},{text: 'Компьютеризированное', value: 2}]"
                  :state="fieldState('control')"
                  stacked
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Прочее" :invalid-feedback="fieldError('commissioning')">
              <b-form-checkbox v-model="innerSet.commissioning" :state="fieldState('commissioning')" switch>
                Пусконаладка
              </b-form-checkbox>
              <b-form-checkbox v-model="innerSet.is_novelty" :state="fieldState('is_novelty')" switch>
                Новинка
              </b-form-checkbox>
              <b-form-checkbox v-model="innerSet.is_bestseller" :state="fieldState('is_bestseller')" switch>
                Бестселлер
              </b-form-checkbox>
              <b-form-checkbox v-model="innerSet.is_active" :state="fieldState('is_active')" switch>
                Опубликован
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-form-row>
      </div>

      <div class="block bg-galsen">
        <h3>Состав</h3>
        <table class="table table-sm table-borderless table-grid table-hover">
          <thead>
          <tr>
            <th width="200">Код</th>
            <th>Наименование</th>
            <th class="fit">Кол-во</th>
            <th width="120">Цена</th>
            <th width="120">Сумма</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="component in innerSet.components" :key="component.id">
            <td>{{ component.code }}</td>
            <td>{{ component.name }}</td>
            <td>{{ component.quantity }}</td>
            <td>{{ component.price | currency }}</td>
            <td>{{ component.price * component.quantity | currency }}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td><b>Итого:</b></td>
            <td><b>{{ price | currency }}&nbsp;₽</b></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="block">
        <h3>Технические характеристики и лабораторные работы</h3>
        <editor-input v-model="innerSet.specs" label="Технические характеристики" name="specs"></editor-input>
        <editor-input v-model="innerSet.experiments" label="Перечень лабораторных работ" name="experiments"></editor-input>
      </div>

      <div class="block bg-galsen">
        <h3>Фотографии</h3>
        <b-form-row align-h="between">
          <div class="col-3">
            <b-file v-model="innerSet.new_media" accept="image/*" browse-text="Выбрать" placeholder="Файл не выбран" multiple></b-file>
          </div>
          <div class="col-1">
            <b-btn type="submit" :disabled="! innerSet.id" variant="outline-primary" block>Загрузить</b-btn>
          </div>
        </b-form-row>

        <b-card-group columns class="mt-3">
          <b-card overlay text-variant="white" :img-src="img"  v-for="(img, imgIndex) in imgPreview" :key="'mediaPreview' + imgIndex">
            <b-card-text>
              <b-btn-group size="sm" vertical>
                <b-btn @click="onPreviewDelete(imgIndex)">
                  <font-awesome-icon icon="trash" />
                </b-btn>
              </b-btn-group>
            </b-card-text>
          </b-card>
          <b-card overlay text-variant="white" :img-src="media.thumb_url" v-for="(media, index) in innerSet.media" :key="'media' + index">
            <b-card-text>
              <b-btn-group size="sm" vertical>
                <b-btn @click="onMediaDelete(media.id)">
                  <font-awesome-icon icon="trash" />
                </b-btn>
              </b-btn-group>
            </b-card-text>
          </b-card>
        </b-card-group>

        <div class="text-right mt-3">
          <b-btn :disabled="! set.can.delete" @click="onDelete()" v-if="innerSet.id"
                 variant="outline-light" class="text-danger mr-3">Удалить</b-btn>
          <b-btn-group>
            <b-btn :disabled="innerSet.id ? ! set.can.update : ! $page.props.can.sets['create']"
                   @click="onSubmit($event)"
                   size="lg" variant="outline-primary">Применить</b-btn>
            <b-btn :disabled="innerSet.id ? ! set.can.update : ! $page.props.can.sets['create']"
                   @click="onSubmit($event, true)"
                   size="lg" variant="outline-primary">Сохранить и закрыть</b-btn>
          </b-btn-group>
        </div>
      </div>
    </b-form>
    <set-components-import-modal id="set-components-import-modal"
                                 :set-id="innerSet.id"
                                 :only-reading="innerSet.id === null"
                                 @read="innerSet.components = $event"></set-components-import-modal>
  </b-card>
</template>

<script>
import MoneyConfig from '~/Components/MoneyConfig'
import SetComponentsImportModal from '~/components/Set/SetComponentsImportModal'
import EditorInput from '~/Components/EditorInput'

const base64Encode = async (data) =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export default {
  components: {
    EditorInput,
    SetComponentsImportModal
  },
  props: {
    set: Object,
    sections: Array
  },
  data () {
    return {
      innerSet: this.$inertia.form({
        id: null,
        section_id: null,
        inner_id: null,
        order: null,
        code: null,
        slug: null,
        experiments: null,
        experiments_count: 1,
        workplaces: 1,
        education_levels: [],
        implementation: 1,
        control: 1,
        commissioning: false,
        is_novelty: false,
        is_bestseller: false,
        is_active: false,
        specs: null,
        components: [],
        media: [],
        new_media: []
      }),
      moneyConfig: MoneyConfig,
      imgSrc: null,
      imgPreview: []
    }
  },
  created () {
    if (this.set) {
      this.innerSet.defaults({ ...this.innerSet, ...this.set })
      this.innerSet.reset()
    }
  },

  methods: {
    onSubmit (event, redirectToList = false) {
      let route = this.route(
        'backend.sets.store',
        { ...(redirectToList && { redirectToList: true }) }
      )

      if (Number.isInteger(this.innerSet.id)) {
        route = this.route(
          'backend.sets.update',
          { set: this.innerSet.id, ...(redirectToList && { redirectToList: true }) }
        )
      }

      this.innerSet
        .transform(data => {
          if (this.set) {
            data._method = 'put'
          }

          const components = {}

          data.components.forEach(component => {
            components[component.id] = { quantity: component.quantity }
          })

          data.components = components

          return data
        })
        .post(route, {
          forceFormData: true,
          onSuccess: (page) => {
            console.log(this.innerSet)
            if (this.set) {
              this.innerSet.defaults({ ...this.innerSet, ...this.set, new_media: [] })
              this.innerSet.reset()
            }
            this.imgPreview = []
          }
        })
    },

    onDelete () {
      if (!confirm('Вы уверены?')) {
        return
      }

      this.$inertia.delete(this.route('backend.sets.destroy', this.innerSet.id))
    },

    async onPreviewDelete (index) {
      this.innerSet.new_media.splice(index, 1)
      this.imgPreview = await this.getPreviews()
    },

    onMediaDelete (id) {
      if (!confirm('Вы уверены?')) {
        return
      }

      window.axios
        .delete(this.route('backend.media.destroy', id))
        .then(resp => {
          if (resp.data.status === 'OK') {
            this.innerSet.media.splice(this.innerSet.media.findIndex(media => media.id === id), 1)
          }
        })
    },

    async getPreviews () {
      const img = []
      for (const file of this.innerSet.new_media) {
        img.push(await base64Encode(file))
      }

      return img
    }
  },
  computed: {
    sectionsOptions () {
      return this.sections.map(rootSection => {
        return {
          label: rootSection.inner_id + ' ' + rootSection.title.replace(/&nbsp;/g, ' '),
          options: rootSection.nested.map(section => ({
            value: section.id,
            html: section.inner_id + ' ' + section.title
          }))
        }
      })
    },

    price () {
      return this.innerSet.id === null
        ? this.innerSet.components.reduce((sum, component) => component.price * component.quantity + sum, 0)
        : this.innerSet.price
    }
  },

  watch: {
    async 'innerSet.new_media' (newValue, oldValue) {
      if (newValue.length === 0 || newValue === oldValue) {
        return
      }

      this.imgPreview = await this.getPreviews()
    }
  }
}
</script>

<style scoped lang="scss">
.block {
  padding: 20px;
}

</style>
